import React from 'react'
import get from 'lodash/get'
import filter from 'lodash/filter'
import moment from 'moment'
import cx from 'classnames'
import storage from 'local-storage-fallback'

let titleStyle = ''

const technicianList = (techs) => techs.map((tech) => (
  `${tech.name} (${tech.completed_area_count})`
))
const noWork = ({status, technicians}) => {
  if (status == 'open' && technicians.length == 0) return false

  // Returns true if there is at least one tech that has neither assigned or claimed areas
  return filter(technicians, 
    (tech) => (tech.completed_area_count == 0) ).length > 0
}

const MonthEvent = ({event, event: { start, status, location, technicians }}) => {
  const {
    unassigned = 'red',
    scheduled = 'navy',
    inProgress = 'lime',
    pendingApproval = 'hotpink',
    archive = 'purple',
  } = JSON.parse(storage.getItem('calendarColors'))

  const color = {
    in_progress: inProgress,
    pending_approval: pendingApproval,
    signed_off: archive,
    open: technicians.length ? scheduled : unassigned
  }

  return (
    <div className={cx({ 'rbc-event': true, 'maats-calendar-month-event': true, 'no-work': noWork(event) })}>
      <div className="rbc-event-content maats-calendar-month-event-content">
        <span className="bullet" style={{ color: get(color, status, 'yellow') }}>•</span>
        <span className="month-event-title">
          {moment(start).format('h:mma')}
          :
          {location.name}
          {technicians && ' - ' + technicianList(technicians).join(', ')}
        </span>
      </div>
    </div>
  )
}

const DayEvent = ({event, event: { location, technicians }}) => (
  <div>
    <span className={cx({'day-event-title': true, 'no-work': noWork(event)})}>
      {location.name}
      {technicians && ' - ' + technicianList(technicians).join(', ')}
    </span>
  </div>
)

export {MonthEvent, DayEvent}



// WEBPACK FOOTER //
// ./src/components/calendar/event.js